/**
 * sessionStorage key for the signed `installState` GitHubEnterprise.tsx stashes right before
 * redirecting the browser to GitHub's install page, and GitHubCallback.tsx reads back out once
 * GitHub redirects to `/integrations/github/callback` — the CSRF-protection round-trip
 * apps/api/src/routes/github.ts's install/start + install/callback expect (see
 * signGitHubInstallState/verifyGitHubInstallState in apps/api/src/auth/jwt.ts). sessionStorage
 * (not localStorage) because this value is only ever needed for the single in-flight redirect.
 */
export const GITHUB_INSTALL_STATE_KEY = 'defendiq.github_install_state';
